import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import CTASection from '../components/CTASection';
import SEO from '../components/SEO';
import { products } from '../mock';
import { CheckCircle2, ArrowUpRight } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function ProductsPage() {
  return (
    <div>
      <SEO
        title="Welding Electrodes — WELDARC, CUTWELD, HITKARI GOLD, SUNLIGHT-13, BPL"
        description="Explore our complete range of premium welding electrodes: WELDARC (E6013), CUTWELD, HITKARI GOLD, SUNLIGHT-13 and BPL. IS 814:2004 certified, made in Kota, India."
        path="/products"
      />
      <Navbar />

      {/* Header */}
      <section className="relative bg-[#0b0b0d] text-white pt-40 pb-24 overflow-hidden noise">
        <div className="absolute inset-0 bg-grid opacity-30" />
        <div className="absolute right-0 top-0 h-96 w-96 rounded-full bg-amber-500/20 blur-3xl" />
        <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
          <div className="font-mono text-[11px] uppercase tracking-[0.18em] text-amber-400 mb-4">
            — Our Complete Range
          </div>
          <h1 className="font-display text-5xl lg:text-6xl font-semibold leading-[1.05] max-w-3xl">
            Exceptional welding electrode brands.
          </h1>
          <p className="mt-6 text-white/70 max-w-2xl text-lg leading-relaxed">
            A wide range of premium welding electrodes tailored to meet diverse industrial
            needs. Designed for superior performance, precision, and durability.
          </p>
        </div>
      </section>

      {/* Products list */}
      <section className="bg-white py-24">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 space-y-24">
          {products.map((p, i) => (
            <div
              key={p.id}
              className={`grid lg:grid-cols-2 gap-12 items-center ${
                i % 2 === 1 ? 'lg:[&>*:first-child]:order-2' : ''
              }`}
            >
              <div className="relative aspect-[4/3] rounded-2xl overflow-hidden bg-gradient-to-br from-neutral-50 via-white to-neutral-100 group border border-neutral-200">
                <div className="absolute inset-0 flex items-center justify-center p-8">
                  <img
                    src={p.image}
                    alt={p.name}
                    className={`${p.imgFit === 'cover' ? 'h-full w-full object-cover' : 'max-h-full max-w-full object-contain'} group-hover:scale-105 transition-transform duration-700`}
                  />
                </div>
                <div className="absolute top-5 left-5 font-mono text-[10px] uppercase tracking-[0.18em] text-[#0b0b0d]/80 bg-white/80 backdrop-blur px-2.5 py-1 rounded border border-neutral-200">
                  0{i + 1} / 0{products.length}
                </div>
              </div>

              <div>
                <div className="font-mono text-[11px] uppercase tracking-[0.18em] text-amber-600 mb-3">
                  {p.subtitle}
                </div>
                <h2 className="font-display text-4xl lg:text-5xl font-semibold text-[#0b0b0d] leading-[1.05]">
                  {p.name}
                </h2>
                <p className="mt-5 text-neutral-600 leading-relaxed">{p.description}</p>

                <div className="mt-7 grid sm:grid-cols-2 gap-3">
                  {p.features.map((f) => (
                    <div
                      key={f}
                      className="flex items-center gap-2.5 rounded-lg bg-neutral-50 border border-neutral-200 px-4 py-3 text-sm text-neutral-800"
                    >
                      <CheckCircle2 className="h-4 w-4 text-amber-600 shrink-0" /> {f}
                    </div>
                  ))}
                </div>

                <Link
                  to="/contact"
                  className="mt-8 inline-flex items-center gap-2 text-[#0b0b0d] font-semibold hover:text-amber-600 transition-colors"
                >
                  Enquire about {p.name} <ArrowUpRight className="h-4 w-4" />
                </Link>
              </div>
            </div>
          ))}
        </div>
      </section>

      <CTASection />
      <Footer />
    </div>
  );
}
